import React from 'react'
import {useHistory} from 'react-router-dom';
import Header from './header'
import IconNav from './iconNav'
import Button from './button'
import './button.css'
function Initial() {
  let history = useHistory();
  const goToDriving = ()=>{
    history.push('/flights')
  }

  return (
    <div className="Initial">
      {window.calculator_options.is_big_sky?(
      <div className="initial-text">
        <div>Offset your trip to Big Sky Resort. This tool will calculate the carbon</div>
        <div>emissions associated with your trip{window.calculator_options.is_big_sky?` to Big Sky`:''}.</div>
      </div>
      ):(
        <div className="initial-text">
          <div>
            Would you like to offset your trip?  This tool will calculate the carbon emissions associated with your travel and visit. 
            </div>
        </div>
      )}
      <div className="buttons">
        <Button className="initial-button primary" onClick={goToDriving}>
          CALCULATE YOUR FOOTPRINT
        </Button>
      </div>
    </div>
  )
}

export default Initial